import {
  GET_EMPLOYEEFACE,
  GET_EMPLOYEEFACE_SUCCESS,
  GET_EMPLOYEEFACE_FAIL,
  DELETE_EMPLOYEEFACE,
  DELETE_EMPLOYEEFACE_SUCCESS,
  DELETE_EMPLOYEEFACE_FAIL,
  UPDATE_EMPLOYEEFACE,
  UPDATE_EMPLOYEEFACE_SUCCESS,
  UPDATE_EMPLOYEEFACE_FAIL,
  ADD_NEW_EMPLOYEEFACE,
  ADD_EMPLOYEEFACE_SUCCESS,
  ADD_EMPLOYEEFACE_FAIL,
  EMPLOYEEFACE_LOADING,
  EMPLOYEEFACE_RESET,
} from "./actionType";

export const resetEmployeeFaceState = (actionType) => ({
  type: EMPLOYEEFACE_RESET,
  payload: { actionType },
});

export const getEmployeeFaceSuccess = (actionType, data) => ({
  type: GET_EMPLOYEEFACE_SUCCESS,
  payload: { actionType, data },
});

export const getEmployeeFaceFail = (actionType, error) => ({
  type: GET_EMPLOYEEFACE_FAIL,
  payload: { actionType, error },
});

export const getEmployeeFace = data => ({
  type: GET_EMPLOYEEFACE,
  payload: data,
});

export const getEmployeeFaceLoading = () => ({
  type: EMPLOYEEFACE_LOADING
});

export const deleteEmployeeFace = data => ({
  type: DELETE_EMPLOYEEFACE,
  payload: data,
});

export const deleteEmployeeFaceSuccess = data => ({
  type: DELETE_EMPLOYEEFACE_SUCCESS,
  payload: data,
});

export const deleteEmployeeFaceFail = error => ({
  type: DELETE_EMPLOYEEFACE_FAIL,
  payload: error,
});

export const updateEmployeeFace = data => ({
  type: UPDATE_EMPLOYEEFACE,
  payload: data,
});

export const updateEmployeeFaceFail = error => ({
  type: UPDATE_EMPLOYEEFACE_FAIL,
  payload: error,
});

export const updateEmployeeFaceSuccess = data => ({
  type: UPDATE_EMPLOYEEFACE_SUCCESS,
  payload: data,
});

export const addNewEmployeeFace = data => ({
  type: ADD_NEW_EMPLOYEEFACE,
  payload: data,
});

export const addEmployeeFaceSuccess = data => ({
  type: ADD_EMPLOYEEFACE_SUCCESS,
  payload: data,
});

export const addEmployeeFaceFail = error => ({
  type: ADD_EMPLOYEEFACE_FAIL,
  payload: error,
});